import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../shared/services/auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  errorMessage: string = '';
  url: string;
  applyRedBg : boolean = false;
  applyBlueBg : boolean = false;

  constructor(
    private readonly authService: AuthService, // Use AuthService for login
  ) {
    this.url = window.location.href;
    
    if(this.url.includes('dev-eligibility') || this.url.includes('localhost:4200/')) {
      this.applyBlueBg = true;
    }
    if(this.url.includes('mts-training')) {
      this.applyRedBg = true;
    }
    console.log('environment',environment);
  }

  ngOnInit(): void {
    if (!sessionStorage.getItem('hasRefreshed')) {
      sessionStorage.setItem('hasRefreshed', 'true');
      window.location.reload();
    } else {
      sessionStorage.removeItem('hasRefreshed');
    }
  }

  signInWithAzureAD() {
    if(this.url.includes('mts-training')) {
      this.applyRedBg = true;
    }
    this.authService.initiateAzureADLogin(); // Initiates Azure AD sign-in
  }
}
